import { render, staticRenderFns } from "./PreviousLicense.vue?vue&type=template&id=60b830b3"
import script from "./PreviousLicense.vue?vue&type=script&lang=js"
export * from "./PreviousLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports